import g from "./_common.js";
import h from "../../_styles/common/light.js";
function c(e) {
  const {
    heightSmall: r,
    heightMedium: t,
    heightLarge: i,
    textColor1: l,
    errorColor: o,
    warningColor: a,
    lineHeight: n,
    textColor3: m
  } = e;
  return Object.assign(Object.assign({}, g), {
    blankHeightSmall: r,
    blankHeightMedium: t,
    blankHeightLarge: i,
    lineHeight: n,
    labelTextColor: l,
    asteriskColor: o,
    feedbackTextColorError: o,
    feedbackTextColorWarning: a,
    feedbackTextColor: m
  });
}
const s = {
  name: "Form",
  common: h,
  self: c
}, C = s;
export {
  C as default,
  c as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/form/styles/light.js
// module id = 956
// module chunks = 67